import { render, staticRenderFns } from "./Alquileres.vue?vue&type=template&id=1c3634da"
import script from "./Alquileres.vue?vue&type=script&lang=js"
export * from "./Alquileres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/concesiones/Alquileres.vue
// module id = null
// module chunks = 